const AmplifyConfig = {
  aws_cognito_region: process.env.REACT_APP_AWS_COGNITO_REGION, // (required) - Region where Amazon Cognito project was created
  aws_user_pools_id:  process.env.REACT_APP_AWS_USER_POOLS_ID, // (optional) -  Amazon Cognito User Pool ID
  aws_user_pools_web_client_id: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID, // (optional) - Amazon Cognito App Client ID (App client secret needs to be disabled)
}

export default AmplifyConfig;
